import api from "@/services/axios.js";
import { VerifySearchValues } from "../../types.ts";
import { searchHandler } from "../../lib/helpers.ts";

export const exportVerificationStagesToVerifyExcel = (
  page: number = 1,
  pageSize: number | string = "",
  search: VerifySearchValues,
) => {
  const payload = searchHandler(search);
  return api.post(
    `/api/AdminVerification/export-verification-stages-to-verify`,
    {
      page,
      pageSize,
      ...payload,
    },
    {
      responseType: "blob",
    },
  );
};
